export default __webpack_public_path__ + "static/timeline-050bd683381cab226b83fc9d18b6f043.png";